import factory from '../requestFactory';

export default ({start_at, end_at, clinic_id, doctor_id, diagnostic_id, specialization_id, patient_id}) => {
    let params = {
        start: start_at,
        end: end_at,
        clinic_id: clinic_id,
    }
    if (specialization_id) {
        params['specialization_id'] = specialization_id
    } else {
        params['diagnostic_id'] = diagnostic_id
    }

    if(patient_id){
        params['patient_id'] = patient_id
    }else{
        params['doctor_id'] = doctor_id
    }

    return factory()
        .get('/time-table', {params: params})

};
